export const ApiPlaces = {
    get: params => ({
        url: '/places',
        method: 'GET',
        params
    }),
    create: (data) => ({
        url: '/places',
        method: 'POST',
        data
    }),
    update: (id, data) => ({
        url: `/places/${id}`,
        method: 'PUT',
        data
    }),
    delete: (id) => ({
        url: `/places/${id}`,
        method: 'DELETE'
    }),
};